// extracted by mini-css-extract-plugin
export default {"page":"u1-z","cartModal":"v1-z","checkout":"w1-z","placeholder":"x1-z","account":"y1-z"};